<div class="main-content">

    <div class="d-flex-filter">
        <app-operator-dropdown (operatorEvent)="operatorEvent($event)"></app-operator-dropdown>
        <app-merchant-dropdown [operator]="operator"
            (onSelectMerchant)="onSelectMerchant($event)"></app-merchant-dropdown>
            <nz-range-picker [(ngModel)]="dateRange" (ngModelChange)="onDateRangeChange($event)"></nz-range-picker>

        <button nz-button nzType="primary" (click)="loadAdsSummaries()">
            <span nz-icon nzType="search"></span>
            Search
        </button>
    </div>


    <nz-table [nzLoading]="loading" style="padding-top: 20px;" #smallTable nzSize="small" [nzData]="adsSummaries"
        [nzScroll]="{ x: '1100px' }">
        <thead>
            <tr>
                <th>Date</th> 
                <th>vendor</th>
                <th>BL</th>
                <th>Robi</th>
                <th>GP</th>
                <th>Total</th> 
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let data of smallTable.data; index as i">
                <td>{{ data.date | date }}</td> 
                <td> {{data.vendor}}</td>
                <td>{{data.blActivation}}</td>
                <td>{{data.robiActivation}}</td>
                <td>{{data.gpActivation}}</td> 
                <td> {{data.totalActivation}}</td>
                
            </tr>          
        </tbody>
    </nz-table>




    <br>

    <!-- <div class="d-flex-archive-filter">
        <nz-range-picker [(ngModel)]="dateRange" (ngModelChange)="onDateRangeChange($event)"></nz-range-picker>
        <span style="padding-left: 10px;"></span>
        <button nz-button nzType="primary" (click)="onArchiveSearch()">
            <span nz-icon nzType="search"></span>
            Search
        </button>
    </div> -->






    <nz-table [nzScroll]="{ x: '1100px' }"  [nzLoading]="archiveLoading" style="padding-top: 20px;" #summaryArchiveTable nzSize="small"
        [nzData]="adsTraffic" [nzScroll]="{ x: '1100px' }">
        <thead>
            <tr>
                <th nzWidth="100px" >Date</th> 
                <th nzWidth="100px" >Operator</th>
                <th nzWidth="130px" >Vendor Name</th>
                <th nzWidth="100px" >Type</th>
                <th nzWidth="100px" >Total</th>
                <th nzWidth="100px" >00-01</th>
                <th nzWidth="100px" >01-02</th>
                <th nzWidth="100px" >02-03</th>
                <th nzWidth="100px" >03-04</th>
                <th nzWidth="100px" >04-05</th>
                <th nzWidth="100px" >05-06</th>
                <th nzWidth="100px" >06-07</th>
                <th nzWidth="100px" >07-08</th>
                <th nzWidth="100px" >08-09</th>
                <th nzWidth="100px" >09-10</th>
                <th nzWidth="100px" >10-11</th>
                <th nzWidth="100px" >11-12</th>
                <th nzWidth="100px" >12-01</th>
                <th nzWidth="100px" >01-02</th>
                <th nzWidth="100px" >02-03</th>
                <th nzWidth="100px" >03-04</th>
                <th nzWidth="100px" >04-05</th>
                <th nzWidth="100px" >05-06</th>
                <th nzWidth="100px" >06-07</th>
                <th nzWidth="100px" >07-08</th>
                <th nzWidth="100px" >08-09</th>
                <th nzWidth="100px" >09-10</th>
                <th nzWidth="100px" >10-11</th>
                <th nzWidth="100px" >11-12</th>
            </tr>
        </thead>
        <tbody>
            <tr  *ngFor="let data of summaryArchiveTable.data">
                <td>{{data.date | date}}</td> 
                <td>{{data.operator}}</td>
                <td>{{data.vendorName}}</td>
                <td>{{data.type}}</td>
                <td>{{data.total}}</td>
                <td>{{data.aM0001}}</td>
                <td>{{data.aM0102}}</td>
                <td>{{data.aM0203}}</td>
                <td>{{data.aM0304}}</td>
                <td>{{data.aM0405}}</td>
                <td>{{data.aM0506}}</td>
                <td>{{data.aM0607}}</td>
                <td>{{data.aM0708}}</td>
                <td>{{data.aM0809}}</td>
                <td>{{data.aM0910}}</td>
                <td>{{data.aM1011}}</td>
                <td>{{data.pM1112}}</td>
                <td>{{data.pM1201}}</td>
                <td>{{data.pM0102}}</td>
                <td>{{data.pM0203}}</td>
                <td>{{data.pM0304}}</td>
                <td>{{data.pM0405}}</td>
                <td>{{data.pM0506}}</td>
                <td>{{data.pM0607}}</td>
                <td>{{data.pM0708}}</td>
                <td>{{data.pM0809}}</td>
                <td>{{data.pM0910}}</td>
                <td>{{data.pM1011}}</td>
                <td>{{data.aM1112}}</td>
               
            </tr> 
        </tbody>
    </nz-table>